<template>
    <b-modal ref="mdlEditPresenza" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg">
        <div class="alert alert-info" v-if="!jsonDataPresenza.tipo === 'USCITA COMPLETATA'">
            <div v-if="jsonDataPresenza.tipo === 'ENTRATA'" class="mt-3">
                <p><strong>Note Uscita Programmata: </strong> {{ jsonDataPresenza.noteUscitaProgrammata || "Nessuna nota" }}</p>
                <p><strong>Note Uscita: </strong> {{ jsonDataPresenza.noteUscita || "Nessuna nota" }}</p>
            </div>
            <div v-if="jsonDataPresenza.tipo === 'USCITA'" class="mt-3">
                <p><strong>Note Programmate:</strong> {{ jsonDataPresenza.noteUscitaProgrammata || "Nessuna nota" }}</p>
            </div>

            <!-- DA VEDERE QUALE SI SCEGLIE, SE QUESTA O LO SPAN CON TUTTE LE NOTE -->

            <!-- <div v-if="jsonDataPresenza.tipo === 'USCITA COMPLETATA'" class="mt-3">
                <p><strong>Note Uscita Programmata: </strong> {{ jsonDataPresenza.noteUscitaProgrammata || "Nessuna nota" }}</p>
                <p><strong>Note Uscita: </strong> {{ jsonDataPresenza.noteUscita || "Nessuna nota" }}</p>
                <p><strong>Note Entrata: </strong> {{ jsonDataPresenza.noteEntrata || "Nessuna nota" }}</p>
            </div> -->
        </div>
        <b-row>
            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Uscita Programmata</label>
                <span v-if="isReadOnly">{{ formatDateTime(jsonDataPresenza.dataOraUscitaProgrammata) }}</span>
                <date-picker v-else format="DD/MM/YYYY HH:mm" value-type="timestamp" v-model="jsonDataPresenza.dataOraUscitaProgrammata" type="datetime" :disabled="isDisabled"></date-picker>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Entrata Programmata</label>
                <span v-if="isReadOnly">{{ formatDateTime(jsonDataPresenza.dataOraEntrataProgrammata) }}</span>
                <date-picker :disabled="isDisabled" v-else format="DD/MM/YYYY HH:mm" value-type="timestamp" v-model="jsonDataPresenza.dataOraEntrataProgrammata" type="datetime"></date-picker>
                <!--:disabled-date="notBeforeUscita"-->
            </b-col>
        </b-row>
        <b-row v-if="!isHidden">
            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Uscita</label>
                <span v-if="isReadOnly">{{ formatDateTime(jsonDataPresenza.dataOraUscita) }}</span>
                <date-picker :disabled="disabledUscita" v-else format="DD/MM/YYYY HH:mm" value-type="timestamp" v-model="dataOraUscitaValue" type="datetime"></date-picker>
            </b-col>

            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Entrata</label>
                <span v-if="isReadOnly">{{ formatDateTime(jsonDataPresenza.dataOraEntrata) }}</span>
                <date-picker v-else :disabled="isEntrataDisabled" format="DD/MM/YYYY HH:mm" value-type="timestamp" v-model="dataOraEntrataValue" type="datetime"></date-picker>
                <!-- :disabled-date="notBefore" -->
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                <label class="sa-label-data">Tipo</label>
                <span v-if="isReadOnly"> {{ jsonDataPresenza.tipo }} </span>
                <b-form-input v-else v-model="jsonDataPresenza.tipo" readonly></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                <label class="sa-label-data">Motivo</label>
                <span v-if="isReadOnly"> {{ jsonDataPresenza.motivo }}</span>
                <b-form-select :disabled="isDisabled" v-else v-model="jsonDataPresenza.motivo" :readonly="isReadOnly" :options="motivoPresenzaUscitaOptions" value-field="voce" text-field="voce" value="''">
                    <template #first>
                        <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                <label class="sa-label-data">Assente nella Data</label>
                <b-form-checkbox v-if="isReadOnly" switch disabled v-model="jsonDataPresenza.assenteNellaData"> </b-form-checkbox>
                <b-form-checkbox v-else v-model="jsonDataPresenza.assenteNellaData" switch> </b-form-checkbox>
            </b-col>

            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <div v-if="isReadOnly">
                    <br />
                    <span> <strong>Note all'uscita programmata: </strong> {{ jsonDataPresenza.noteUscitaProgrammata || "Nessuna nota" }}</span
                    ><br />
                    <span> <strong>Note all'uscita: </strong> {{ jsonDataPresenza.noteUscita || "Nessuna nota" }}</span
                    ><br />
                    <span> <strong>Note all'entrata: </strong> {{ jsonDataPresenza.noteEntrata || "Nessuna nota" }}</span>
                </div>
                <div v-else>
                    <label class="sa-label-data">Note</label>
                    <b-form-textarea v-model="notaCorrente" rows="3" max-rows="7" :placeholder="'Inserisci ' + placeholderNote + ' qui...'"> </b-form-textarea>
                </div>
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button v-if="!isReadOnly" size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
            <b-button v-if="!isReadOnly" size="md" variant="outline-success" @click="onClickOk">Salva</b-button>
            <b-button v-if="isReadOnly" size="md" variant="outline-secondary" @click="onCloseModal">Chiudi</b-button>
        </template>
        <modal-error ref="cmpModalError"> </modal-error>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
//import moment from "moment";
export default {
    name: "RsaSchedaOspiteUsciteEditComponent",
    mixins: [UtilityMixin],
    components: { DatePicker, ModalError },
    props: {},

    data() {
        return {
            title: null,
            isReadOnly: false,
            isDisabled: false,
            isHidden: false,
            pathResource: "/rsapazientepresenze",
            pathResourceDizionario: "/rsadizionario",
            jsonDataPresenza: {
                id: null,
                idAccettazione: null,
                dataOraUscitaProgrammata: new Date(),
                dataOraUscita: new Date(),
                dataOraEntrataProgrammata: new Date(),
                dataOraEntrata: new Date(),
                tipo: null,
                motivo: null,
                assenteNellaData: null,
                noteUscitaProgrammata: null,
                noteUscita: null,
                noteEntrata: null,
            },
            motivoPresenzaUscitaOptions: [],
            jsonDataAccettazione: {},
        };
    },
    computed: {
        notaCorrente: {
            get() {
                let me = this;
                //Sfrutto il titolo per gestire le note
                if (me.tipo === "USCITA") {
                    return me.jsonDataPresenza.noteUscita;
                } else if (me.tipo === "ENTRATA") {
                    return me.jsonDataPresenza.noteEntrata;
                } else {
                    return me.jsonDataPresenza.noteUscitaProgrammata;
                }
            },
            set(value) {
                let me = this;
                //imposto il valore nel campo corretto
                if (me.title === "Registra Uscita") {
                    me.jsonDataPresenza.noteUscita = value;
                } else if (me.title === "Registra Entrata") {
                    me.jsonDataPresenza.noteEntrata = value;
                } else {
                    me.jsonDataPresenza.noteUscitaProgrammata = value;
                }
            },
        },
        placeholderNote() {
            let me = this;

            if (me.title === "Registra Uscita") {
                return "note per l'uscita";
            } else if (me.title === "Registra Entrata") {
                return "note per l'entrata";
            } else {
                return "note per l'uscita programmata";
            }
        },
        isEntrataDisabled() {
            let me = this;
            return me.title === "Registra Uscita";
        },
        /* dataOraUscitaValue: {
            get() {
                return this.jsonDataPresenza.dataOraUscita || new Date().getTime();
            },
            set(value) {
                this.jsonDataPresenza.dataOraUscita = value;
            },
        }, */

        dataOraUscitaValue: {
            get() {
                let me = this;
                // Se il valore esiste, lo restituisco
                if (me.jsonDataPresenza.dataOraUscita) {
                    return me.jsonDataPresenza.dataOraUscita;
                }
                // DA VALUTARE DI USARE IL 'TIPO' ANZICHE IL TITOLO PER GESTIRE TUTTE QUESTE SITUAZIONI
                if (me.title === "Registra Uscita") {
                    let currentTime = new Date().getTime();
                    return currentTime;
                }
                return null;
            },
            set(value) {
                let me = this;
                // console.log("SET dataOraUscitaValue - title:", me.title);
                // console.log("SET dataOraUscitaValue - nuovo valore:", value);
                me.jsonDataPresenza.dataOraUscita = value;
                // console.log("SET dataOraUscitaValue - valore salvato:", me.jsonDataPresenza.dataOraUscita);
            },
        },
        dataOraEntrataValue: {
            get() {
                let me = this;
                if (me.jsonDataPresenza.dataOraEntrata) {
                    return me.jsonDataPresenza.dataOraEntrata;
                }
                if (me.title === "Registra Entrata") {
                    let currentTime = new Date().getTime();
                    return currentTime;
                }
                // Altrimenti restituisco null (per non interferire con altri flussi)
                return null;
            },
            set(value) {
                this.jsonDataPresenza.dataOraEntrata = value;
            },
        },
        disabledUscita() {
            let me = this;

            // Se è in modalità "Registra Uscita", NON disabilitare mai
            if (me.title === "Registra Uscita") {
                return false;
            }

            // Se è in modalità "Registra Entrata" E l'uscita è già stata effettuata, disabilita
            if (me.title === "Registra Entrata" && me.jsonDataPresenza.dataOraUscita) {
                return true;
            }

            // Per tutti gli altri casi, usa la logica originale
            return me.isDisabled && !!me.jsonDataPresenza.dataOraUscita;
        },
    },
    mounted() {
        let me = this;
        me.loadDizionarioData();
    },
    watch: {
        // "jsonDataPresenza.dataOraUscitaProgrammata": {
        //     handler: "notBeforeUscita",
        //     immediate: true,
        // },
    },

    /* computed: {
        assenteNellaData: {
            get() {
                let me = this;

                return me.getValore(me.jsonDataPresenza.assenteNellaData);
            },
            set(value) {
                let me = this;
                me.setValore(value, "assenteNellaData");
            },
        },
    }, */
    methods: {
        init(jsonDataAccettazione, item, isEdit, isReadOnly, isDisabled) {
            let me = this;
            if (jsonDataAccettazione) {
                me.jsonDataAccettazione = jsonDataAccettazione;
            }
            me.show(item, isEdit, isReadOnly, isDisabled);
        },
        // ==================== METODI PRINCIPALI ====================
        loadDizionarioData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceDizionario, null, me.loadDizionarioDataSuccess, me.loadDizionarioDataError);
        },

        loadDizionarioDataSuccess(response) {
            let me = this;
            if (response.data?.data?.list) {
                me.motivoPresenzaUscitaOptions = response.data.data.list.filter((item) => item.tipo === "MOTIVAZIONE_PRESENZE_USCITE");
            }
        },
        loadDizionarioDataError(error) {
            console.error("Errore nel caricamento delle motivazioni", error);
        },
        show(jsonData, isEdit, isReadOnly, isDisabled) {
            let me = this;
            // console.log("JSON DATA SHOW()", jsonData);
            me.jsonDataPresenza = jsonData;
            me.isReadOnly = isReadOnly;
            me.isDisabled = isDisabled;
            // console.log("jsonDataPresenza in show: ", me.jsonDataPresenza);
            // console.log("isEdit: ", isEdit);
            // console.log("isReadOnly: ", isReadOnly);
            // console.log("isDisabled: ", isDisabled);

            if (isEdit) {
                me.title = !me.jsonDataPresenza.id ? "Nuova Uscita Programmata" : "Aggiorna Uscita Programmata";
            } else if (isReadOnly) {
                me.title = "Visualizza Uscita";
            } else {
                me.title = !me.jsonDataPresenza.dataOraUscita ? "Registra Uscita" : "Registra Entrata";
            }
            me.isHidden = !me.jsonDataPresenza.id ? true : false;
            // console.log("isHidden", this.isHidden);
            if (me.jsonDataAccettazione.statoAttuale === "DIMESSO" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO") {
                me.$bvModal.msgBoxOk("Non è possibile modificare le uscite di un paziente dimesso o trasferito", {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
                return;
            }
            me.loadDizionarioData();
            me.$refs.mdlEditPresenza.show();
            // Inizializza le date se necessario
            if (me.title === "Registra Uscita" && !me.jsonDataPresenza.dataOraUscita) {
                // console.log('Inizializzo dataOraUscita per "Registra Uscita"');
                me.jsonDataPresenza.dataOraUscita = new Date().getTime();
            }

            if (me.title === "Registra Entrata" && !me.jsonDataPresenza.dataOraEntrata) {
                // console.log('Inizializzo dataOraEntrata per "Registra Entrata"');
                me.jsonDataPresenza.dataOraEntrata = new Date().getTime();
            }
            /*
            // Logica per determinare il titolo della modale
    if (!jsonData.dataOraUscitaProgrammata && !jsonData.dataOraEntrataProgrammata) {
        // Caso: nuova presenza/uscita (nessuna data programmata)
        me.title = !me.jsonDataPresenza.id ? "Nuova presenza/uscita" : "Aggiorna presenza/uscita";
    } else {
        // Caso: presenza/uscita programmata esistente
        // Correzione: usa jsonDataPresenza invece di jsonData
        if (!me.jsonDataPresenza.dataOraUscita && !me.jsonDataPresenza.dataOraEntrata) {
            // Nessuna uscita e nessuna entrata registrata -> Registra Uscita
            me.title = "Registra Uscita";
        } else if (me.jsonDataPresenza.dataOraUscita && !me.jsonDataPresenza.dataOraEntrata) {
            // Uscita registrata ma non l'entrata -> Registra Entrata
            me.title = "Registra Entrata";
        } else if (me.jsonDataPresenza.dataOraUscita && me.jsonDataPresenza.dataOraEntrata) {
            // Entrambe registrate -> Visualizza/Modifica
            me.title = "Visualizza presenza/uscita";
        } else {
            // Caso di fallback
            me.title = "Modifica presenza/uscita";
        }
    } */
        },
        // ==================== UTILITY ====================
        onCloseModal() {
            let me = this;
            me.jsonDataPresenza = {
                id: null,
                idAccettazione: null,
                dataOraUscitaProgrammata: new Date(),
                dataOraUscita: new Date(),
                dataOraEntrataProgrammata: new Date(),
                dataOraEntrata: new Date(),
                tipo: null,
                motivo: null,
                assenteNellaData: null,
                noteUscitaProgrammata: null,
                noteUscita: null,
                noteEntrata: null,
            };
            me.$refs.mdlEditPresenza.hide();
            me.$emit("onClose");
        },
        // ==================== GESTIONE SALVATAGGIO ====================
        onClickOk() {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonDataPresenza, me.saveSuccessResponse, me.saveErrorResponse);
        },
        saveSuccessResponse(response) {
            let me = this;
            me.$emit("onSave", response);
            me.$refs.mdlEditPresenza.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        saveErrorResponse(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },

        /* notAfter: function (date) {
            return date > Date.now();
        }, */

        // notBeforeUscita: function () {
        //     let me = this;
        //     return Date(me.jsonDataPresenza.dataOraUscitaProgrammata) < Date.now(me.jsonDataPresenza.dataOraEntrataProgrammata);
        // },

        /* notBefore: function (date) {
            return date < Date.now();
        }, */
        /* getValore(data) {
            return data === "SI";
        },
        setValore(value, data) {
            let me = this;
            me.jsonDataPresenza[data] = value ? "SI" : "NO";
        }, */
    },
};
</script>
